import { render } from "./BuyNavLink.vue?vue&type=template&id=194a64f9&scoped=true"
import script from "./BuyNavLink.vue?vue&type=script&lang=js"
export * from "./BuyNavLink.vue?vue&type=script&lang=js"

import "./BuyNavLink.vue?vue&type=style&index=0&id=194a64f9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-194a64f9"]])

export default __exports__